module.exports = __webpack_public_path__ + "media/Text_center_+_sub.c4968f22.mp4";